import { useEffect, useState } from "react";
import InvoiceInfoHeader from "./InvoiceInfoHeader";
import InvoiceInfoLine from "./InvoiceInfoLine";

function InvoiceVatInfo({ data }) {
  const [vatPerCategory, setVatPerCategory] = useState({});
  useEffect(() => {
    let vatData = {};
    for (let info of data) {
      if (!vatData[info.vatCategoryDescription]) vatData[info.vatCategoryDescription] = 0;
      vatData[info.vatCategoryDescription] += info.vatAmount;
    }
    setVatPerCategory(vatData);
  }, [data]);

  return (
    <>
      <InvoiceInfoHeader title={"Στοιχεία Φ.Π.Α."} />
      <InvoiceInfoLine title={"Κατηγορία Φ.Π.Α."} text={"Ποσό"} align={"right"} />
      {Object.keys(vatPerCategory).map((key) => (
        <InvoiceInfoLine
          key={`invoice-vat-line-${key}`}
          title={key}
          text={vatPerCategory[key].toFixed(2)}
          align={"right"}
        />
      ))}
    </>
  );
}

export default InvoiceVatInfo;
